import { useEffect, useState } from 'react'
import { useParticipar } from '../../../hooks/useParticipacion'
import { useUsuario } from '../../../hooks/useUsuario'
import { clientesFeria, clientesRedes } from '../../../modelos/cliente'
import { Estados, TEMPORADA } from '../../../utilidades/constants'
import Cargando from './cargando'
import { Mensaje } from './mensaje'
import Contador from '../../../componentes/contador'

const DEBUG_MODE = false

export const Resultado = ({ cliente, usuario, fromRedes }) => {
    const [error, setError] = useState()
    const { puedeParticipar, participar, haParticipado } = useParticipar()
    const [estado, setEstado] = useState(Estados.PARTICIPANDO)

    useEffect(() => {
        setError(undefined)
        setEstado(Estados.PARTICIPANDO)
        const clientes = fromRedes ? clientesRedes : clientesFeria

        const guardarParticipacion = async () => {
            try {
                if (cliente?.codigo === 'extra') {
                    return
                }
                const finalRedes = usuario.numParticipacionesRedes + 1 === clientesRedes.length
                const finalFeria = usuario.numParticipaciones + 1 === clientesFeria.length
                const numParticipaciones =
                    (fromRedes ? usuario.numParticipacionesRedes : usuario.numParticipaciones) || 0

                await participar(cliente, fromRedes)
                if (numParticipaciones === 0) {
                    setEstado(Estados.PRIMERA)
                } else if (finalRedes && !finalFeria) {
                    setEstado(Estados.FIN_REDES)
                } else if (finalFeria && !finalRedes) {
                    setEstado(Estados.FIN_FERIA)
                } else if (numParticipaciones + 1 < clientes.length) {
                    setEstado(Estados.VARIAS)
                } else {
                    setEstado(Estados.ULTIMA)
                }
            } catch (error) {
                setEstado(Estados.ERROR)
                setError(error?.message || error)
            }
        }

        if (!cliente) {
            setEstado(Estados.ERROR)
            setError('Ups.. este destino no existe.')
        } else if (usuario?.reference?.id) {
            if (haParticipado(cliente, fromRedes)) {
                setEstado(Estados.HA_PARTICIPADO)
            } else if (puedeParticipar(cliente, fromRedes)) {
                guardarParticipacion()
            } else {
                setError('A este destino ya llegaste!')
                setEstado(Estados.ERROR)
            }
        } else {
            setError('No se ha podido verificar el usuario. Vuelva a intentarlo.')
            setEstado(Estados.ERROR)
        }
    }, [cliente, fromRedes])

    if (DEBUG_MODE) {
        console.log(error, estado)
        return <PantallaFinalFeria fromRedes={fromRedes} />
    }
    if (estado === Estados.PARTICIPANDO) return <Cargando />

    if (estado === Estados.VARIAS) {
        return <PantallaVarias fromRedes={fromRedes} />
    }

    if (estado === Estados.PRIMERA) {
        return <PantallaPrimera fromRedes={fromRedes} />
    }

    if (
        estado === Estados.ERROR ||
        estado === Estados.NO_VALIDO ||
        estado === Estados.HA_PARTICIPADO
    ) {
        return <PantallaError fromRedes={fromRedes} repetido={estado === Estados.HA_PARTICIPADO} />
    }

    if (estado === Estados.FIN_FERIA) {
        return <PantallaFinalFeria fromRedes={estado === Estados.FIN_REDES} />
    }

    if (estado === Estados.ULTIMA || estado === Estados.FIN_REDES) {
        return <PantallaFinal fromRedes={fromRedes} />
    }

    return <>{error}</>
}

/**
 * Entre 1 y clientes.length - 1 participaciones
 */
const PantallaVarias = ({ fromRedes }) => {
    const { usuario } = useUsuario()
    const numParticipacionesRedes = usuario?.numParticipacionesRedes || 0
    const numParticipacionesFeria = usuario?.numParticipaciones || 0
    const restantes = fromRedes
        ? clientesRedes.length - numParticipacionesRedes
        : clientesFeria.length - numParticipacionesFeria

    const mensaje = fromRedes
        ? `¡¡Has sumado ${numParticipacionesRedes} participaciones para el sorteo a través de redes sociales!!`
        : `Ya tienes ${numParticipacionesFeria} participaciones para el sorteo. ${restantes} estaciones te esperan.`
    const icono = fromRedes ? '/assets/img/resultados/x-rrss.png' : '/assets/img/resultados/x.png'
    const imagen = fromRedes
        ? '/assets/img/resultados/img-5.png'
        : '/assets/img/resultados/img-2.png'

    return (
        <div className="wrapper">
            <img src={icono} alt={mensaje} />
            <Mensaje mensaje={mensaje} />
            {!fromRedes && <Contador fromRedes={fromRedes} className="my-8" />}
            {fromRedes && (
                <div
                    style={{ '--image-url': `url('/assets/img/resultados/background.png')` }}
                    className="bg-[image:var(--image-url)] bg-cover bg-no-repeat bg-top h-44 flex items-center justify-center">
                    <Contador fromRedes={fromRedes} />
                </div>
            )}
            <img className="mt-6" src={imagen} alt={mensaje} />
        </div>
    )
}

/**
 * Primera participación
 */
const PantallaPrimera = ({ fromRedes }) => {
    const { usuario } = useUsuario()
    const numParticipacionesRedes = usuario?.numParticipacionesRedes || 0
    const numParticipacionesFeria = usuario?.numParticipaciones || 0
    const restantes = fromRedes
        ? clientesRedes.length - numParticipacionesRedes
        : clientesFeria.length - numParticipacionesFeria

    const mensaje = fromRedes
        ? `¡¡Has sumado ${numParticipacionesRedes} participaciones para el sorteo a través de redes sociales!!`
        : `¡Has conseguido tu primera participación! Te quedan ${restantes} etapas por saborear. Cada QR te acerca a una Air Fryer`
    const icono = fromRedes ? '/assets/img/resultados/x-rrss.png' : '/assets/img/resultados/1.png'
    const imagen = fromRedes
        ? '/assets/img/resultados/img-5.png'
        : '/assets/img/resultados/img-1.png'

    return (
        <div className="wrapper">
            <img src={icono} alt={mensaje} />
            <Mensaje mensaje={mensaje} />
            {!fromRedes && <Contador fromRedes={fromRedes} className="my-8" />}
            {fromRedes && (
                <div
                    style={{ '--image-url': `url('/assets/img/resultados/background.png')` }}
                    className="bg-[image:var(--image-url)] bg-cover bg-no-repeat bg-top h-44 flex items-center justify-center">
                    <Contador fromRedes={fromRedes} />
                </div>
            )}
            <img className="mt-6" src={imagen} alt={mensaje} />
        </div>
    )
}

const PantallaError = ({ repetido = false }) => {
    const mensaje = repetido
        ? '¡No te detengas! 💪🏻 Continúa sumando destinos a tu lista! '
        : '¡No te detengas! 💪🏻 Continúa sumando destinos a tu lista! '
    const icono = '/assets/img/resultados/error.png'
    const imagen = '/assets/img/resultados/img-1.png'
    return (
        <div className="wrapper">
            <img src={icono} alt={mensaje} />
            <Mensaje mensaje={mensaje} />
            {<Contador fromRedes={false} className="my-8" />}
            <img className="mt-6" src={imagen} alt={mensaje} />
        </div>
    )
}

const PantallaFinal = ({ fromRedes = false }) => {
    const { usuario } = useUsuario()
    const numParticipacionesRedes = usuario?.numParticipacionesRedes || 0
    const numParticipacionesFeria = usuario?.numParticipaciones || 0
    const totalParticipaciones = numParticipacionesRedes + numParticipacionesFeria

    const mensaje = fromRedes
        ? `¡¡Has conseguido todas las participaciones para el sorteo!! Tienes ${totalParticipaciones} participaciones.`
        : `¡¡Has conseguido todas las participaciones para el sorteo!! Tienes ${totalParticipaciones} participaciones.`
    const icono = fromRedes
        ? '/assets/img/resultados/completado.png'
        : '/assets/img/resultados/completado.png'
    const imagen = fromRedes
        ? '/assets/img/resultados/img-5.png'
        : '/assets/img/resultados/img-5.png'

    return (
        <div className="wrapper">
            <img src={icono} alt={mensaje} />
            <Mensaje mensaje={mensaje} />
            <div
                style={{ '--image-url': `url('/assets/img/resultados/background.png')` }}
                className="bg-[image:var(--image-url)] bg-cover bg-no-repeat bg-top h-44 flex items-center justify-center">
                <Contador fromRedes={fromRedes} />
            </div>
            <img className="mt-6" src={imagen} alt={mensaje} />
        </div>
    )
}

const PantallaFinalFeria = ({ fromRedes }) => {
    const mensaje = fromRedes
        ? `¡${clientesRedes.length} etapas de tu viaje alcanzadas para el sorteo! Gracias por recorrer el año del sabor con nosotros. ¡Has conseguido tu participación extra!`
        : `¡${clientesFeria.length} etapas de tu viaje alcanzadas para el sorteo! Gracias por recorrer el año del sabor con nosotros. ¡Has conseguido tu participación extra!`
    const icono = fromRedes
        ? '/assets/img/resultados/x-rrss.png'
        : '/assets/img/resultados/todas.png'
    const imagen = fromRedes
        ? '/assets/img/resultados/img-5.png'
        : '/assets/img/resultados/img-5.png'

    return (
        <div className="wrapper">
            <img src={icono} alt={mensaje} />
            <Mensaje mensaje={mensaje} />
            <div className="flex items-center justify-center mt-4 mb-8">
                <img
                    className="max-w-32"
                    src={`/assets/img/slider/${TEMPORADA}/grid/extra-a.jpg`}
                    alt={mensaje}
                />
            </div>
            <div
                style={{ '--image-url': `url('/assets/img/resultados/background.png')` }}
                className="bg-[image:var(--image-url)] bg-cover bg-no-repeat bg-top h-44 flex items-center justify-center">
                <Contador fromRedes={fromRedes} />
            </div>
            <img className="mt-6" src={imagen} alt={mensaje} />
        </div>
    )
}
